import Api from './api'

export const getUserInfo = async () => {
  const user = await Api.get('/me')
  return user
}
